import client from '@xFrame4/business/GraphQlClient';

export default client;